import { PagedList } from '../../admin/types/pagination';
import { MainV3ApiBase } from './base';
import { UserId } from '../../mainv2/types/user';
import { CourseWorkSubmissionIndexView } from '../types/course_work_submissions';

export type SubmissionQueryParams = {
  review_status: 'completed' | 'uncompleted';
  reviewer_id: UserId | null;
  course_ids: string;
  max_days_before_deadline: number;
};

export const CourseWorkSubmissionApis = {
  async findAll(
    page = 1,
    params: Partial<SubmissionQueryParams> = {}
  ): Promise<PagedList<CourseWorkSubmissionIndexView>> {
    return PagedList.fromJson(await MainV3ApiBase.appendPath('course_work_submissions').get({ page, ...params }));
  },
};
